module.exports = __webpack_public_path__ + "static/media/sound.cb68d6a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound.mp3
// module id = ARz0
// module chunks = 1